import { BatchesService } from '@festina/moneyout-general-types/moneyout/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitMoneyOutBatch = () =>
  useFestinaMutation({
    component: 'moneyOut',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
